//状态列表
export const STATES = {
    enabled: 1,
    disabled: 0
};

//状态名称
export const STATE_NAMES = {
    1: '启用',
    0: '禁用'
}


//状态名称
export const STATE_NAMES_IS = {
    1: '未使用',
    2: '已使用',
    3: '已过期'
}

//类型列表
export const TYPES = {
    api: 1,
    route: 2,
    btn: 3,
    fileds: 4
}

//类型名称
export const TYPE_NAMES = {
    1: 'API',
    2: '路由',
    3: '按钮',
    4: '字段'
}

//方法类型
export const METHODS = {
    get: 1,
    post: 2,
    put: 3,
    patch: 4,
    delete: 5
}


//方法名称
export const METHOD_NAMES = {
    1: 'GET',
    2: 'POST',
    3: 'PUT',
    4: 'PATCH',
    5: 'DELETE'
}

//是否公共方法
export const IS_PUBLIC = {
    yes: 1,
    no: 0
}

//是否公共方法名称
export const IS_PUBLIC_NAMES = {
    1: '公共资源',
    0: '私有资源'
}

export const TIME_LIST = {
    1: '每分钟',
    2: '每小时',
    3: '每天',
    4: '每月',
    5: '每年',
}